module.exports = __webpack_public_path__ + "static/media/AdvitoLogo.ccbfe134.png";